import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import css from "./ShipmentPage.scss"
import PrimaryRadioSelection from "@widgets/PrimaryRadioSelection/PrimaryRadioSelection.skeleton"
import CarePlanUpsellCheckbox from "@widgets/CarePlanUpsellCheckbox/CarePlanUpsellCheckbox.skeleton"
const ButtonConfig = [{ span: 10, height: "40px", classes: "marginTop-8" }]
const AddressSelectionCollapsedConfig = [{ span: 10, height: "42px", classes: "marginTop-8" }]
const VerticalDivider = [{ span: 2 }]
const FootnoteConfig = [{ span: 10, height: "36px", classes: "marginTop-8" }]
const SeparatorConfig = [{ span: 10, height: "8px" }]
const SeparatorConfigSmall = [{ span: 10, height: "4px" }]

function ShipmentSkeleton() {
    return (
        <div className="page-container">
            <div className={`container-fluid flex padding-8-0 ${css.pageHeight}`}>
                <div className="flexColumn">
                    <div className="widget-container marginBoth-8">
                        <Skeleton config={PrimaryRadioSelection} isComponent></Skeleton>
                    </div>
                </div>
                <div className="flex-column">
                    <Skeleton config={VerticalDivider} isComponent></Skeleton>
                </div>
                <div className="flexColumn">
                    <div className="widget-container marginBoth-8">
                        <Skeleton config={CarePlanUpsellCheckbox} isComponent></Skeleton>
                    </div>
                    <div className="col-10">
                        <Skeleton config={SeparatorConfig} isComponent></Skeleton>
                    </div>

                    <div className="widget-container marginBoth-8">
                        <Skeleton config={AddressSelectionCollapsedConfig} isComponent></Skeleton>
                    </div>
                    <div className="col-10">
                        <Skeleton config={SeparatorConfigSmall} isComponent></Skeleton>
                    </div>
                    <div className="col-10 widget-container marginBoth-8">
                        <Skeleton config={ButtonConfig} isComponent></Skeleton>
                    </div>
                    <div className="widget-container marginBoth-8">
                        <Skeleton config={FootnoteConfig} isComponent></Skeleton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShipmentSkeleton
